function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { hasSlot } from "common/util/dom";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { CheckboxEl } from "common/components/checkbox";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { FieldWithMatches } from "./cell-mixins";
const sanitizeClassName = (className) => className ? className.replace(/ /g, "-") : "";
const ColumnTitle = (_ref) => {
  let {
    column,
    colIndex,
    columnTitle
  } = _ref;
  return column.titleRenderer ? column.titleRenderer(column, {
    colIndex,
    title: columnTitle
  }) : /* @__PURE__ */ jsx("div", { sel: ".text" }, columnTitle);
};
const CellTypeText = (_ref2) => {
  let {
    item,
    context
  } = _ref2;
  return /* @__PURE__ */ jsx(FieldWithMatches, { item, context, "data-sentry-element": "FieldWithMatches", "data-sentry-component": "CellTypeText", "data-sentry-source-file": "template.tsx" });
};
const CellTypeCollapsible = (_ref3) => {
  let {
    rowIdx,
    item,
    component
  } = _ref3;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-table-collapsible", "data-sentry-component": "CellTypeCollapsible", "data-sentry-source-file": "template.tsx" }, !item.isExpandingDisabled && /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    icon: item.isExpanded ? "caret-down" : "caret-right",
    theme: ButtonTheme.Tertiary
  }, on: {
    click: (ev) => component.helpers.handleCollapsibleCaretClick(ev, item, rowIdx)
  } }));
};
const CellTypeCheckbox = (_ref4) => {
  let {
    item,
    context,
    component
  } = _ref4;
  const options = component.helpers.getCheckboxState(item);
  return /* @__PURE__ */ jsx("div", { sel: ".mp-table-checkbox-wrapper", class: {
    disabled: options.attrs.disabled,
    "will-range-select": component.helpers.willRangeSelect(context.rowIdx)
  }, on: {
    click: (ev) => !options.attrs.disabled && component.helpers.toggleSelected(ev, item, context.rowIdx)
  }, attrs: {
    title: component.helpers.rangeSelectAllowed() ? "shift + click for range select" : ""
  }, "data-sentry-component": "CellTypeCheckbox", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(CheckboxEl, { attrs: _objectSpread(_objectSpread({}, options.attrs), {}, {
    elref: "mpTableCheckbox"
  }), "data-sentry-element": "CheckboxEl", "data-sentry-source-file": "template.tsx" }), options.selectDisabledReason && options.attrs.disabled ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Right
  } }, options.selectDisabledReason) : null);
};
function renderResizeHandles(_ref5) {
  let {
    table,
    columns,
    resizingColumnIndex
  } = _ref5;
  return columns.map((column, idx) => {
    const isResizing = resizingColumnIndex === idx;
    const hiddenFinalColumn = !table.attr("allow-x-overflow") && idx === columns.length - 1;
    return /* @__PURE__ */ jsx("div", { sel: ".column-resize-handle", class: {
      "is-resizing": isResizing,
      "other-resizing": Boolean(resizingColumnIndex) && !isResizing
    }, style: !column.isResizable || hiddenFinalColumn || table.state.isDetailHovered ? {
      display: "none"
    } : {}, on: {
      pointerdown: (ev) => table.onResizePointerDown({
        ev,
        resizeColumnIndex: idx
      })
    } });
  }).filter(Boolean);
}
export function template() {
  const {
    draggingColumnIndex,
    hasBodyScrolled,
    rowDetailsRenderer,
    sortField,
    sortOrder
  } = this.state;
  const draggableColumns = this.attr("draggable-columns");
  const {
    t
  } = this.getContext("i18n");
  const rowsToDisplay = this.helpers.getRowsToDisplay();
  const colsToDisplay = this.helpers.getColumnsToDisplay();
  return /* @__PURE__ */ jsx("div", { sel: ".mp-table", attrs: {
    role: "table"
  }, on: {
    scroll: !this.attr("window-scroll") && this.helpers.handleTableScroll
  }, class: {
    "mp-table-allow-x-overflow": this.attr("allow-x-overflow"),
    "min-table-width": !!this.attr("min-table-width")
  }, style: {
    minWidth: this.attr("min-table-width")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, (() => {
    const isSticky = this.attr("sticky-titles") && !this.attr("loading");
    return /* @__PURE__ */ jsx(null, null, !this.attr("hide-titles") ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-titles", class: {
      "mp-table-titles-sticky": isSticky
    }, hook: isSticky && !this.attr("disable-page-sticky-titles") ? this.helpers.stickyElemHooks : {} }, colsToDisplay.map((column, colIndex) => {
      const isCurrSortField = sortField === column.field;
      const isDraggable = draggableColumns && column.field !== "isSelected" && this.helpers.isColumnDraggable(colIndex);
      return /* @__PURE__ */ jsx("div", { sel: ".mp-table-title-cell", attrs: {
        role: "columnheader"
      }, class: {
        "mp-table-can-sort": column.isSortable,
        "mp-table-is-draggable": isDraggable,
        "mp-table-sort-column": isCurrSortField,
        ["mp-table-title-cell-type-".concat(column.type)]: !!column.type,
        ["title-cell-field-".concat(sanitizeClassName(column.field))]: true,
        "drop-indicator-left": draggableColumns && this.helpers.isDroppingLeft(colIndex),
        "drop-indicator-right": draggableColumns && this.helpers.isDroppingRight(colIndex)
      }, style: _objectSpread({
        flexGrow: column.flexGrow || "0"
      }, column.computedWidth ? {
        boxSizing: "border-box",
        minWidth: "".concat(column.computedWidth, "px"),
        maxWidth: "".concat(column.computedWidth, "px")
      } : {
        flexBasis: column.flexBasis
      }), on: {
        click: () => this.helpers.handleHeaderTitleClick(column),
        dragenter: () => this.helpers.handleTitleDragEnter(colIndex),
        dragover: (ev) => this.helpers.handleTitleDragOver(ev, colIndex),
        dragleave: this.helpers.handleTitleStepDragLeave,
        dragend: this.helpers.handleTitleStepDragEnd,
        drop: (ev) => this.helpers.handleTitleDrop(ev, colIndex),
        mousedown: (ev) => this.helpers.handleTitleMouseDown(ev, colIndex),
        mouseup: this.helpers.handleTitleMouseUp
      } }, column.type === "collapsible" ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-collapsible" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
        icon: "collapse",
        theme: ButtonTheme.Tertiary
      }, on: {
        click: () => this.helpers.handleCollapseAll()
      } })) : null, column.type === "checkbox" ? (
        // checkbox-wrapper so we can increase click surface area
        /* @__PURE__ */ jsx("div", { sel: ".mp-table-checkbox-wrapper", style: {
          pointerEvents: this.attr("multi-select") ? "" : "none"
        }, on: {
          click: this.helpers.toggleAllSelected
        } }, this.attr("multi-select") ? (() => {
          const {
            numSelected,
            allSelected
          } = this.helpers.getSelectionStats();
          return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(CheckboxEl, { attrs: {
            checked: allSelected,
            "unchecked-icon": numSelected > 0 ? "dash" : ""
          } }), this.attr("selection-limit") ? /* @__PURE__ */ jsx(TooltipEl, { params: {
            text: t("components.table.selection-limit-notice", {
              limit: this.attr("selection-limit")
            })
          } }) : null);
        })() : null)
      ) : null, isDraggable ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-drag-controls", attrs: {
        draggable: String(isDraggable)
      }, on: {
        dragstart: (ev) => this.helpers.handleTitleDragStart(ev, colIndex)
      } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
        icon: "gripper"
      } })) : null, column.title ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-title-label" }, (() => {
        const maxLength = column.titleMaxLength || this.helpers.COLUMN_TITLE_MAX_LENGTH;
        const columnTitle = column.title.length > maxLength ? this.helpers.truncateMiddle(column.title, maxLength) : column.title;
        return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ColumnTitle, { column, colIndex, columnTitle }), column.title.length > maxLength && colIndex !== draggingColumnIndex ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
          "max-width": "250px",
          placement: Placement.Top
        } }, column.title) : null);
      })()) : null, column.titleIcon ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-title-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
        icon: column.titleIcon
      } }), column.titleTooltip ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
        "max-width": "250px",
        placement: Placement.Top
      } }, column.titleTooltip) : null) : null, column.helpText ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-title-help-text" }, (() => {
        const hrefVal = column.helpLink ? column.helpLink : "javascript:void(0)";
        return /* @__PURE__ */ jsx(null, null, column.helpLink ? /* @__PURE__ */ jsx("a", { attrs: {
          href: hrefVal,
          target: "_blank"
        }, class: {
          "mp-table-title-help-link": !!column.helpLink
        } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
          icon: "info"
        } })) : /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
          icon: "info"
        } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
          "max-width": "250px",
          placement: column.helpTextPlacement
        } }, column.helpText));
      })()) : null, column.isSortable ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-sort-controls", class: {
        ["mp-table-sort-".concat(sortOrder === 1 ? "asc" : "desc")]: isCurrSortField
      } }, /* @__PURE__ */ jsx("div", { sel: ".mp-table-sort-caret-up" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
        icon: "caret-up"
      } })), /* @__PURE__ */ jsx("div", { sel: ".mp-table-sort-caret-down" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
        icon: "caret-down"
      } }))) : null);
    }), renderResizeHandles({
      table: this,
      columns: colsToDisplay,
      resizingColumnIndex: this.state.resizeColumnIndex
    })) : null, /* @__PURE__ */ jsx("div", { sel: ".mp-table-body", class: {
      "mp-table-body-clickable": !this.attr("disable-clickable-rows") && !this.attr("loading"),
      "mp-table-body-scroll": !this.attr("window-scroll") && !this.attr("sticky-row-mode"),
      "mp-table-body-scrolled": hasBodyScrolled,
      "mp-table-body-sticky": this.attr("sticky-row-mode")
    }, style: {
      maxHeight: this.attr("max-body-height")
    }, on: {
      mouseleave: this.helpers.handleBodyMouseLeave,
      mouseenter: this.helpers.handleBodyMouseEnter,
      scroll: !this.attr("window-scroll") && this.helpers.handleScroll
    }, hook: {
      insert: (_ref6) => {
        let {
          elm
        } = _ref6;
        return this.helpers.handleTableBodyInserted(elm);
      }
    } }, this.attr("loading") ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-row.mp-table-row-loading", hook: {
      init: this.helpers.handleTableLoading,
      destroy: this.helpers.handleTableLoaded
    } }, [...Array(5)].map(() => /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }))) : rowsToDisplay.length ? (() => {
      const needsRowMouseEnter = this.attr("row-focused-context") || this.attr("multi-select");
      let prevRowContexts = null;
      const isGroupingEnabled = this.helpers.isGroupingEnabled();
      return /* @__PURE__ */ jsx(null, null, rowsToDisplay.map((row, rowIdx, arr) => /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-table-row.mp-table-body-row", class: {
        ["mp-table-row-no-border"]: isGroupingEnabled,
        ["mp-table-row-selected"]: row.val.isSelected,
        ["mp-table-row-no-bottom-border"]: row.val.isExpanded && !row.val.isSticky,
        ["mp-table-row-no-background-hover"]: this.attr("disable-row-background-hover"),
        ["mp-table-row-sticky"]: row.val.isSticky,
        ["mp-table-row-relative"]: !row.val.isSticky
      }, on: {
        contextmenu: (ev) => this.helpers.handleContextMenu(ev, row.val, rowIdx),
        click: (ev) => this.helpers.handleRowClick(ev, row.val, rowIdx),
        mouseenter: needsRowMouseEnter && (() => this.helpers.handleRowMouseEnter(rowIdx))
      }, hook: {
        insert: rowIdx === arr.length - 1 && this.helpers.handleInitialRender
      }, attrs: {
        elref: "mpTableRow",
        role: "row"
      }, key: rowIdx }, (() => {
        const currRowContexts = this.helpers.getCellRenderContexts(colsToDisplay, row, rowIdx, rowsToDisplay.length);
        const groupedColIndices = isGroupingEnabled && this.helpers.getGroupedColIndices(colsToDisplay, prevRowContexts, currRowContexts);
        prevRowContexts = currRowContexts;
        return /* @__PURE__ */ jsx(null, null, row.val.isNew ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-new-row-indicator" }) : null, colsToDisplay.map((column, columnIdx) => {
          const columnType = this.helpers.getColumnType(row.val, column);
          const context = currRowContexts[columnIdx];
          const cellRenderer = column.cellRenderer;
          let CellRendererMixin;
          if (!cellRenderer) {
            switch (columnType) {
              case "checkbox":
                CellRendererMixin = CellTypeCheckbox;
                break;
              case "collapsible":
                CellRendererMixin = CellTypeCollapsible;
                break;
              default:
                CellRendererMixin = CellTypeText;
                break;
            }
          }
          return /* @__PURE__ */ jsx("div", { sel: ".mp-table-cell", key: column.field, attrs: {
            role: "cell"
          }, class: {
            ["cell-field-".concat(sanitizeClassName(column.field))]: true,
            ["mp-table-cell-has-right-border"]: isGroupingEnabled && column.isGroupable,
            ["mp-table-cell-has-top-border"]: isGroupingEnabled && rowIdx > 0 && !groupedColIndices.has(columnIdx),
            ["mp-table-cell-sortable"]: column.isSortable,
            ["mp-table-cell-type-".concat(columnType)]: !!columnType,
            "drop-indicator-left": this.helpers.isDroppingLeft(columnIdx),
            "drop-indicator-right": this.helpers.isDroppingRight(columnIdx)
          }, style: _objectSpread({
            flexGrow: column.flexGrow || "0"
          }, column.computedWidth ? {
            boxSizing: "border-box",
            minWidth: "".concat(column.computedWidth, "px"),
            maxWidth: "".concat(column.computedWidth, "px")
          } : {
            flexBasis: column.flexBasis
          }), on: {
            click: (ev) => this.helpers.handleCellClick(ev, row.val, column.field, context)
          } }, !(isGroupingEnabled && groupedColIndices.has(columnIdx)) ? cellRenderer ? cellRenderer(row.val, context) : CellRendererMixin ? /* @__PURE__ */ jsx(CellRendererMixin, { rowIdx, item: row.val, context, component: this }) : /* @__PURE__ */ jsx(CellTypeText, { item: row.val, context }) : null);
        }));
      })()), rowDetailsRenderer && row.val.isExpanded ? /* @__PURE__ */ jsx("div", { sel: ".mp-table-row-details".concat(this.attr("disable-expandable-rows-indent") ? ".mp-table-row-details-no-indent" : ""), on: {
        mouseenter: () => {
          this.update({
            isDetailHovered: true
          });
        },
        mouseleave: () => {
          this.update({
            isDetailHovered: false
          });
        }
      } }, rowDetailsRenderer(row.val)) : null)), Array.from({
        length: this.attr("min-row-count") - rowsToDisplay.length
      }).map((_) => /* @__PURE__ */ jsx("div", { sel: ".mp-table-row.mp-table-row-no-border.mp-table-padding-row" })));
    })() : /* @__PURE__ */ jsx("div", { sel: ".mp-table-row.mp-table-row-empty" }, this.attr("search-filter").trim() ? t("components.table.no-results") : hasSlot(this, "table-empty-message") ? /* @__PURE__ */ jsx("slot", { attrs: {
      name: "table-empty-message"
    } }) : this.attr("empty-message") || t("components.table.empty"))));
  })());
}
